import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function CtaSection() {
  return <section id="contact" className="py-32 bg-navy-900 relative overflow-hidden" data-id="element-12">
      {/* Geometric Background */}
      <div className="absolute inset-0 bg-grid-pattern-light opacity-[0.05]" data-id="element-13"></div>
      <div className="absolute -top-40 -right-40 w-96 h-96 border border-white/10 rounded-full" data-id="element-14"></div>
      <div className="absolute -bottom-20 -left-20 w-64 h-64 border border-white/10 clip-hexagon" data-id="element-15"></div>

      <div className="container mx-auto px-6 max-w-4xl relative z-10 text-center" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-17">
          <div className="w-16 h-1 bg-white mx-auto mb-10" data-id="element-18"></div>
          <h2 className="text-5xl md:text-6xl font-heading font-bold text-white mb-8 tracking-tight" data-id="element-19">
            Ready to turn content into pipeline?
          </h2>
          <p className="text-xl text-slate-300 mb-12 max-w-2xl mx-auto font-light" data-id="element-20">
            Schedule a strategy call with our architecture team. We'll audit
            your current approach and map out a blueprint for growth.
          </p>

          <a href="#" className="inline-flex items-center justify-center gap-3 bg-white text-navy-900 px-10 py-5 font-bold text-lg hover:bg-slate-100 transition-colors group" data-id="element-21">
            Book a Strategy Call
            <ArrowRight className="group-hover:translate-x-1 transition-transform" data-id="element-22" />
          </a>
        </motion.div>
      </div>
    </section>;
}